import React, { useRef } from "react";
import * as Icons from "react-feather";
import Modal from "./Modal";

export default function PlayPreviewModal(props) {
  

  return (
    <Modal show={props.show} size={'modal-2lg'} title={props.title} handleClose={props.close}>
      <iframe allow="fullscreen" src={`https://hashure.com/play-preview/${props.id}?using_token=${localStorage.getItem('token')}`} style={{height:"75vh",width:"100%"}} title="Iframe Example"></iframe> 
    </Modal>
  );
}
